module.exports = __webpack_public_path__ + "5be4aeeea714e9c3dc27241933998173.svg";